import type { LucideIcon } from 'lucide-react';

import styles from './settings.module.css';

interface Props {
  title: string;
  sub?: string;
  phase: number;
  icon: LucideIcon;
  body: string;
  chips?: { label: string; phase: number }[];
}

export function StubPage({ title, sub, phase, icon: Icon, body, chips }: Props) {
  return (
    <>
      <div className={styles.pageHead}>
        <h1>{title}</h1>
        {sub ? <p className={styles.pageSub}>{sub}</p> : null}
      </div>

      <div className={styles.stubCard}>
        <div className={styles.stubIcon} aria-hidden="true">
          <Icon size={48} />
        </div>
        <span className={styles.stubPhase}>זמין ב-Phase {String(phase)}</span>
        <p className={styles.stubBody}>{body}</p>

        {chips && chips.length > 0 ? (
          <div className={styles.chipRow}>
            {chips.map((c) => (
              <span key={c.label} className={styles.chip}>
                {c.label}
                <small>P{String(c.phase)}</small>
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </>
  );
}
